import styled from "styled-components";

export const OverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 32px;
  gap: 32px;  
`;

export const BasicInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;   
`

export const BasicInformationHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const BasicInformationContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;   
  padding: 0 24px;
  gap:24px;
  flex-wrap: wrap;
`

export const BasicInformationContentAvatar = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;  
`

export const BasicInformationContentData = styled.div`
  display: flex;
  flex-direction: row;
  gap: 80px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
  }
`

export const BasicInformationContentDataItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;  
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const InfoItemRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${(props) => (props?.gapSpacing ? props.gapSpacing : '4px')};
  justify-content: flex-start;
  align-items: center;
`

export const LoginInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;   
  gap: 24px;  
`

export const LoginInformationContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;   
  gap: 12px;  
  width: 100%;  
  
  & > div {
    flex: 0 0 calc((100% - 24px) / 3);
    min-width: 0;
    align-self: stretch;
    
    @media (max-width: 768px) {
      flex: 0 0 calc((100% - 12px) / 2);
    }
    
    @media (max-width: 480px) {
      flex: 0 0 100%;
    }
  }
`
export const LoginInformationContentCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;  
`

export const LoginInformationContentCardLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: flex-start;  
`

export const LoginInformationContentCardRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  
`
export const MultiFactor = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;  
  gap: 24px;  
`

export const MultiFactorHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;  
`

export const MultiFactorState = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;  
`

export const MultiFactorStateLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;  
`

export const MultiFactorStateRight = styled.div`
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px 
`

export const BasicInformationNotifications = styled.div`
    display:  ${props => props.showNotificationDisabled ? 'flex' : 'none'};
  width: 100%;
`

export const BasicInformationNotificationsInvExpired = styled.div`
  display:  ${props => props.showInvitationExpired ? 'flex' : 'none'};
  width: 100%;
`

export const BasicInformationNotificationsInvSent = styled.div`
  display:  ${props => props.showInvitationSent ? 'flex' : 'none'};
  width: 100%;
`